import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const groupNameAtom = atom<string | undefined>({
    default: "마진맥스",
    key: ATOM_KEY.GROUP_NAME,
});

export const useGroupNameState = () => useRecoilState(groupNameAtom);
export const useSetGroupNameState = () => useSetRecoilState(groupNameAtom);
export const useGroupNameValue = () => useRecoilValue(groupNameAtom);
